import React, {useState, useRef} from 'react'
import { AiOutlineComment } from 'react-icons/ai';
import {useStateContext} from '../context/StateContext';
import {CommentIcon, VisDiv} from './';
import Comment from './Comment';
import { v4 as uuidv4 } from 'uuid'; 
import { successAlert, errorAlert, keyId, sortByPostedOn, addLogToDoc, fromBase64ToSanity } from '../lib/utils';
import { useUploadPhoto, useUploadFile } from '../hooks/mutations'
import { clientUser, facilityClient } from '../lib/userPermissions';
import {Photos, PhotosBeforeAfter} from './';
import {FieldDropdown} from './';
import ModalContent from './ModalContent';
import { AiFillCamera } from 'react-icons/ai';
import useNetworkStatus from '../hooks/useNetworkStatus';
import { FaFilePdf } from "react-icons/fa";
import ImageCrop from './imageCrop/ImageCrop';
import PdfFilesManagement from './PdfFilesManagement';
import { PdfDocumentPin } from './PdfDocumentPin';
import {InsertPhotoSanity, InsertPhoto} from './';




const Comments = ({destination, editFn, hideRead, device}) => {
 
    const networkStatus = useNetworkStatus()

    const [comment, setComment] = useState('');
    const [addingComment, setAddingComment] = useState(false);
    const [pdfs, setPdfs] = useState([]);
    const [photo, setPhoto] = useState(undefined);
    const [commentNonConformity, setCommentNonConformity] = useState()
    const {sUser, client, LDB, nonConformities, site, register, modalOpen, setModalOpen, setModalContent } = useStateContext();
    const [viewArchived, setViewArchived] = useState(false)
    const commentRef = useRef()
    const [pdfToggle, setPdfToggle] = useState(false)
    const testing = false

    const emptyDoc = () => ({ comment, nonConformity:{}, postedOn: Date.now(), images:[], pdfs:[], postedBy: { _type: 'postedBy', _ref: sUser?._id }, status:"DA LEGGERE", _key: keyId(), _id:uuidv4(), _type:"comment" })
    
    const [doc, setDoc] = useState(emptyDoc());

    const deviceNonConformities = device?.nonConformities?.filter?.((x)=>x?.status !== "ARCHIVIATO")?.map?.((item)=>{
      const nonConformity = !nonConformities ? undefined : nonConformities?.find?.((x)=>x?._id == item?.nonConformity?._ref)
      const doc = {label: nonConformity?.label, value: nonConformity?.label, nonConformityId:nonConformity?._id, deviceNonConformityId: item?._id }
      return doc
    })

  const editComment = (data=[]) => {
    setDoc({...data, lastEditOn: Date?.now()})
    setComment(data?.comment)
    setPdfs(data?.pdfs ? data?.pdfs : [])
  }  

  const testFunction = () => {
      console.log(doc, device)
      //console.log(nestedArray)
  }
  
  const insertComment = () => {
    console.log("insert comment liawuehfb", doc)
    editFn(doc)
    setAddingComment(false)
    setDoc(emptyDoc())
    setComment("")
    setPdfToggle(false)
  } 
  const commentsArray = () => {
    if(!clientUser(sUser)) return destination?.comments?.filter?.((x)=> x?.severe)
    return destination?.comments
  }

  //PICTURES

/**
 * 
 * @param {*} data
 * @returns a doc with a picture
 */
const updatePictureDoc = (data)=> {
    const pictures = doc?.images ? doc?.images : []
    const newPictureId = uuidv4()
    const beforePictureBase64Doc = {
      _key: keyId(), 
      _id: newPictureId, 
      _type:"beforeAfterPhoto", 
      before: {
        base64Image: data?.src ? data : { src: data },
        beforeOrAfter:"before", 
        beforeAfterPhotoId: newPictureId, 
        postedOn: Date.now(), 
        postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId()},
      }
    }
    const newDoc = {...doc, images:[...pictures.filter?.((x=>x?._key !== data?._key)), beforePictureBase64Doc ] }
    return (newDoc)
}
const updatePictureSanityDoc = (data)=> {
  const pictures = doc?.images? doc?.images : []
  const newPictureId = uuidv4()
  const beforePictureSanity4Doc ={
    _key: keyId(), 
    _id: newPictureId, 
    _type:"beforeAfterPhoto", 
    before: {
      sanityImage: data,  
      beforeOrAfter:"before", 
      beforeAfterPhotoId: newPictureId, 
      postedOn: Date.now(), 
      postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId()}
    }
  }
  const newDoc = {...doc, images:[...pictures.filter?.((x=>x?._key !== data?._key)), beforePictureSanity4Doc] }
  return (newDoc)
}



  const insertPicture = (data) => {
    const newDoc = updatePictureDoc(data)
    const docWithLog = addLogToDoc(sUser,newDoc,"Picture Added/Updated")
    console.log("INSERT OFFLINE PICTURE jdcdchn", docWithLog, "data", data)
    setDoc(docWithLog)
    setAddingComment(true)
    //saveFn(docWithLog)
}
const insertPictureSanity = (data) => {
    const newDoc = updatePictureSanityDoc(data)
    const docWithLog = addLogToDoc(sUser,newDoc,"Picture Added/Updated")
    console.log("INSERT SANITY PICTURE ewerjweriejr", docWithLog)
    setDoc(docWithLog)
    setAddingComment(true)

    //saveFn(docWithLog)
}

const {mutate: uploadPhotoAsset} = useUploadPhoto({
  onError:()=>{
      errorAlert("UPLOAD FOTO NON RIUSCITO")
    } 
})



const updatePdfs = (data) => {
  const newDoc = {...doc, pdfs: data}
  console.log("UPDATE PDFS", newDoc)
  setDoc({...doc, pdfs: data})
}

const saveCroppedPhoto = (data) => {
  console.log("SAVE CROPPED PHOTO", data)
  setPhoto(data)
  
}
const croppingFn = (data) => {
  console.log("IS CROPPING", data)
  //setCropping(data)
}

const saveBeforePhoto = async(data) => {
  if(!networkStatus) return insertPicture(data)
  
  await fromBase64ToSanity(data)
      ?.then((file)=>{
        console.log("SAVE BEFORE PHOTO AFTER conversion webdjewhdb", file)
        const fileWithoutMetaData = {
          type: file?.file?.type,
          name: file?.file?.name,
          size: file?.file?.size,
          lastModified: file?.file?.lastModified,
          webkitRelativePath: file?.file?.webkitRelativePath
        }
        //console.log("Without metadata", {...file, file:fileWithoutMetaData})
        uploadPhotoAsset(file,{
          onSuccess:(asset)=>{
          const sanityPicDoc = {
              _type: 'image',
              _key: keyId(),
              asset: {
                  _type: 'reference',
                  _ref: asset?._id,
                  _key: keyId()
                },
              
            }
          insertPictureSanity(sanityPicDoc)  

        },
        onError:(err)=>{
          errorAlert("ERRORE UPLOAD FOTO")
        }

          })  

          //saveFn(doc)
          
      })
  
}

/* const modalContent = (item) =>    
  <ModalContent 
      setOpenModal={setModalOpen}
      setModalContent={setModalContent}
      title={"Take Picture Modal"}
      savePictureBase64 = {saveBeforePhoto}
      continueTo={()=>{
      //console.log("continue from parent")
  }}
      takePicture= {true}
  /> */


/*   const takePic = (e) => {

      e?.stopPropagation()
      //setImage(camera.current.takePhoto())
      console.log("TAKE PIC")
      setModalContent(modalContent())
      setModalOpen(!modalOpen);
  } */

  return (
  
  <>

    <div className='new-device-container-top' style={{marginTop:"5px", marginBottom:"5px",}}>
        <h2>{LDB("misc", "comments")}</h2>

        <VisDiv rules={[testing]}>
            <button onClick={testFunction}>test</button>
        </VisDiv>
        <VisDiv rules={[device, clientUser(sUser)]}>
            <FieldDropdown
                isSearchable="isSearchable"
                placeHolder={"ASSEGNA NON CONFORMITA'"}
                options={deviceNonConformities}
                initialValue={doc?.nonConformity}
                onChange={(value) => { 
                    console.log("nc value:",value)
                    setCommentNonConformity(value)
                    setDoc({...doc, nonConformity: {label: value?.label, nonConformityId: value?.nonConformityId, deviceNonConformityId: value?.deviceNonConformityId}})
                }}
            />
        </VisDiv>
    <VisDiv rules={[clientUser(sUser), facilityClient(client, sUser)]} style={{display: "flex", alignItems:"center", justifyContent:"center", marginTop:"15px"}}>
        <textarea
            ref={commentRef}
            type="text"
            value={comment}
            onChange={(e) => {
              const value = e.target.value
              setDoc({...doc, comment: value})
              setComment(value)}}
            placeholder = {LDB("misc", "insertComment")}
            className={"text-input"}
            style={{ borderRadius: "10px", height:"80px"}}
         />
    </VisDiv>
    <VisDiv rules={[doc?.pdfs?.length > 0, clientUser(sUser)]}>
      {doc?.pdfs?.map?.((item, index) => {
        return(
        <div style={{marginTop:"15px"}} key={item?.pdfId}>
          <PdfDocumentPin viewOnly= {true} pdf={item} hideAddPdfButton={true}  pdfs={doc?.pdfs} setPdfs={updatePdfs} />
        </div>
      )})}
    </VisDiv>
    <VisDiv rules={[clientUser(sUser)]} style={{display: "flex", alignItems:"center", marginTop:"15px",  marginBottom:"25px"}}>
{/*       <button style={{marginLeft:"10px"}} onClick={(e)=>takePic(e)} className='round-button-no-hover'>
              <AiFillCamera
              size={25}
              color={"white"}
              />
      </button> */}
      <VisDiv rules={[true, networkStatus, facilityClient(client, sUser), clientUser(sUser)]}>
        <InsertPhotoSanity
            saveSanityFn={insertPictureSanity}
        /> 
      </VisDiv>
      <VisDiv rules={[true, !networkStatus, facilityClient(client, sUser), clientUser(sUser)]}>
          <InsertPhoto
              saveFn={insertPicture}
          />
      </VisDiv>
      <button onClick={()=>setPdfToggle(!pdfToggle)} style={{backgroundColor:"green", marginLeft:"10px", marginRight:"10px"}} className='round-red-button'>
        <FaFilePdf
        size={22}
        color={"white"}
        />
      </button>
      
        { (comment || addingComment) && <CommentIcon
          onClick={()=>insertComment()}
          />}
    </VisDiv>
    <VisDiv rules={[pdfToggle, clientUser(sUser)]}>
      <PdfFilesManagement 
        isLoaded = {pdfToggle}
        addPdfToComment={true} 
        clientDetails={
          {
            deviceId: device?._id, 
            registerId:register?._id, 
            siteId: site?._id, 
            clientId: client?._id}
          } 
        pdfs ={doc?.pdfs} 
        setPdfs={updatePdfs}/>
    </VisDiv>
    <VisDiv rules={[true]}style={{marginTop:"10px", zIndex:"1000"}}>

    </VisDiv>
    <VisDiv rules={[true, doc?.images?.length > 0]}>
      <PhotosBeforeAfter
        saveFn = {setDoc}
        enableDelete = {true}
        doc = {doc}
        hideAfterPictureIcon={true}
      />
    </VisDiv>  

    <VisDiv rules={[clientUser(sUser), facilityClient(client, sUser)]} style={{display:"flex", }}>
      <button className={viewArchived ? 'view-button' :'not-view-button'}  onClick={()=>setViewArchived(!viewArchived)}>
        {LDB("misc", "archivedComments")}
      </button>
    </VisDiv>
    <VisDiv rules={[commentsArray()]}>
      {commentsArray()?.sort(sortByPostedOn).map?.((comment, index)=>(
        <div key={index}>
                <VisDiv rules={[viewArchived, comment?.status == "ARCHIVIATO"]}>
                <Comment
                    index={index}
                    comment={comment}
                    editFn={editFn}
              
                />
              </VisDiv> 
              <VisDiv rules={[!viewArchived, comment?.status !== "ARCHIVIATO"]} >
                <Comment
                    index={index}
                    comment={comment}
                    editFn={editFn}
                    hideRead = {hideRead}
                    setCommentToEdit={editComment}
                />
            </VisDiv> 
        </div>
      ))
      }
    </VisDiv>
    <VisDiv rules={[!commentsArray() || commentsArray().length < 1]}>
      <div className='horizontal-swipe-box' style={{ 
        border: "2px dashed", 
        borderRadius:"10px", 
        height: "60px", 
        width:"320px", 
        display:"flex", 
        alignItems:"center", 
        justifyContent:"center", 
        marginTop:"25px",
        textAlign:"center" }}
        >
          {LDB("misc", "noComments")}
      </div>
    </VisDiv>
    
    </div>
  </>
  )
}

export default Comments
